import { createUserTracking } from '@thehotelsnetwork/vue-user-tracking';

function isSyntheticTest() {
  return /Datadog/i.test(navigator.userAgent);
}

export const userTracking = createUserTracking({
  token: import.meta.env.VUE_APP_MIXPANEL_TOKEN,
  disabled: !import.meta.env.PROD || isSyntheticTest(),
});

export * from './trackingEvents';
